// extracted by mini-css-extract-plugin
export default {"title":"Page404_title__ay79N","subTitle":"Page404_subTitle__wecag"};